export default {
  clearModuleCacheEnabled: (state) => state.clearModuleCacheEnabled,
  ceEnvironment: (state) => state.ceEnvironment
};
